var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9551 7.293C11.8741 7.114 11.6961 7 11.5001 7H9.50006V0.5C9.50006 0.224 9.27606 0 9.00006 0H7.00006C6.72406 0 6.50006 0.224 6.50006 0.5V7H4.50006C4.30406 7 4.12606 7.115 4.04506 7.293C3.96306 7.472 3.99506 7.681 4.12406 7.829L7.62406 11.829C7.71906 11.938 7.85606 12 8.00006 12C8.14406 12 8.28106 11.937 8.37606 11.829L11.8761 7.829C12.0061 7.682 12.0361 7.472 11.9551 7.293Z",
    fill: "#00C8D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11V14H2.5V11H0.5V15C0.5 15.553 0.948 16 1.5 16H14.5C15.053 16 15.5 15.553 15.5 15V11H13.5Z",
    fill: "#00C8D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.e8c729b3a55afe439bd5c8956c1b1115.svg";
export { ForwardRef as ReactComponent };